/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSignaturePadResponse } from '../../models/create-signature-pad-response';
import { KeyType } from '../../models/key-type';

export interface PostConsigneeSignaturePad$Params {
  organizationSiteKey: KeyType;
  checkinKey: KeyType;
}

export function postConsigneeSignaturePad(http: HttpClient, rootUrl: string, params: PostConsigneeSignaturePad$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSignaturePadResponse>> {
  const rb = new RequestBuilder(rootUrl, postConsigneeSignaturePad.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSignaturePadResponse>;
    })
  );
}

postConsigneeSignaturePad.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/signature-pads';
